import React, { useEffect, useState } from 'react';
import { Outlet, Route, Routes, useNavigate } from 'react-router';
import './document.css'
import ListComponent from './ListComponent';
import Folder from './folder/Folder';
import Folder2 from './folder/Folder2';
import Folder3 from './folder/Folder3';
import { useSelector, useDispatch } from 'react-redux';
import { setAllCategory } from '../../../redux/action/Action';
import { POST_CATEGORIES } from '../../../helpers/endpointService';
import axios from 'axios';
import { logoutFunction } from '../../custom/commonFunction';

// import { setCategoryData } from '../../../redux/action/Action';
// import Select from "react-select"
// import arrowright from "../../../assets/svg/arrow-right.svg";
// import arrowleft from "../../../assets/svg/arrow-left.svg"

const Document = () => {

    const nav = useNavigate();
    const dispatch = useDispatch();
    let { documentList, menuToggle } = useSelector((state) => ({
        documentList: state.documentReducer.document,
        menuToggle: state.commonReducer.menuToggle
    }));

    // const [currentPage, setCurrentPage] = useState(1);
    // const [perPage, setPerPage] = useState(20);
    // const [pageCount, setPageCount] = useState(1);
    const [isMobile, setisMobile] = useState(false);
    // // const [currentFolder, setCurrentFolder] = useState([]);
    // // const [category1, setCategory1] = useState()
    // const paginglist = [{ "label": "5", "value": 5 }, { "label": "10", "value": 10 }, { "label": "20", "value": 20 }, { "label": "50", "value": 50 }]
    // const paginglistDefault = [{ "label": "20", "value": 20 }]

    useEffect(() => {

        fetchData()
        const intervals = setInterval(() => {
            resize()
        }, 10);
        return () => clearInterval(intervals);

    }, []);

    const fetchData = async () => {

        let apiUrl = `${POST_CATEGORIES}`;

        axios({
            method: "POST",
            url: apiUrl,
            data: null
        })
            .then((response) => {

                if (response?.status === 200) {
                    dispatch(setAllCategory(response.data))

                    // console.log(response.data)
                }

            })
            .catch(err => {
                logoutFunction(err?.response?.status);
                console.log(err)
            });
    };

    // const fetchData = async () => {

    //     let apiUrl = `${POST_CATEGORIES}`;
    //     const pageDetails = {
    //            pageNumber: currentPage,
    //            pageSize: perPage,
    //            sortBy: "",
    //            orderBy: ""
    //          }

    //     axios({
    //      method: "POST",
    //      url: apiUrl,
    //      data: pageDetails
    //      })
    //      .then((response) => {

    //      if (response?.status === 200) {
    //          dispatch(setCategoryData(response.data))
    //          setPageCount(response.data.totalPages)

    //          // console.log(response.data)
    //         }

    //       })
    //       .catch(err => {
    //         console.log(err)
    //   });
    // };


    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
    }


    ////////////////////////////////// pagination /////////////////////////////////////////

    //   const find = e => {
    //         setPerPage(parseInt(e.value) )
    //   }
    //   const previousPage = () => {
    //         setCurrentPage(current => current - 1)
    // }

    //   const nextPage = () => {
    //     setCurrentPage(current => current + 1)
    // }

    // useEffect(()=> {
    //     fetchData()
    // },[currentPage, perPage])   




    return (
        <div className={isMobile ? "document-container-mob document" : !menuToggle ? `document-container-open document` : `document-container document`}>


            <Routes>
                <Route path='' element={<ListComponent />} />
                <Route path='/:category1Id' element={<Folder />} />
                <Route path='/:category1Id/:category2Id' element={<Folder2 />} />
                <Route path='/:category1Id/:category2Id/:docId' element={<Folder3 />} />
            </Routes>


            {/* <div className='fileList'>
                <table className='fileListTable'>
                    <thead>
                        <tr>
                            <td><div><img src={blankFile} alt='' /> <span>Name</span><img src={downArrow} alt='' /> </div> </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><img src={folder} alt='' /> <span>Content</span></td>
                        </tr>
                        <tr>
                            <td><img src={folder} alt='' /> <span>Quiz</span></td>
                        </tr>
                        <tr>
                            <td><img src={folder} alt='' /> <span>General</span></td>
                        </tr>
                    </tbody>
                </table>
            </div> */}

            {/* <div className={`${isMobile ? "common-mobilesubmenu mobile-pagination" :menuToggle? "common-submenu sidemenu-pagination": "common-submenu web-pagination" } pb-2`}>
          <table width="100%">
                            <tbody>
                                <tr>
                                    <td width="8%" className='p-3'>
                                        <div style={{ minWidth: '80px', maxWidth: '80px' }}>
                                            <Select
                                                options={paginglist}
                                                defaultValue={paginglistDefault}
                                                classNamePrefix="paging"
                                                isSearchable={false}
                                                menuPlacement={"top"}
                                                menuPosition={'fixed'}
                                                onChange={e => find(e)}
                                            />
                                        </div>
                                    </td>
                                    <td width="92%" className='text-end p-3'>
                                        {currentPage == 1 ? '' : <img src={arrowleft} className='px-1 cursor-pointer' onClick={previousPage} />}<label className="text-12-bold">{currentPage}</label>{pageCount === currentPage ? '' : <img src={arrowright} className='px-1 cursor-pointer' onClick={nextPage} />}
                                    </td>
                                </tr>
                            </tbody>
          </table>
        </div> */}
        </div>
    )
}

export default Document;